
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[domain]/policy",
      function () {
        return require("private-next-pages/[domain]/policy/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[domain]/policy"])
      });
    }
  